import http from "../../http-common";

class NewsArticlesRightSideLearningService {
    getNewsArticlesRightSideLearningService(productPath: string) {
        return http.get(`/right-side-section/news-articles/learning?nodeName=${productPath}`);
    }
}

export default new NewsArticlesRightSideLearningService();
